import {
  ConfirmationBox,
  HeadingGroup,
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import useContact from "./useContact";
import AddNote from "./AddNote";
import EmptyData from "../../Global/EmptyData";

const ContactUs = () => {
  const {
    isLoading,
    isFetching,
    contactList,
    contactState,
    showEditModal,
    paginationOptions,
    handleEditColumnsClick,
    updateContactFields,
    handleEditAction,
    handleCloseModal,
    handleDeleteModal,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleDelete,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  } = useContact();

  return (
    <>
      <HeadingGroup title="Contact Us" className={`pro-mb-4`} />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={contactState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: contactState?.search }}
          handleActionClick={handleEditColumnsClick}
        />
        {contactList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={contactList?.data?.result || []}
            uniqueID={"id"}
            fields={contactList?.data?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            deleteIcon={
              <span className="material-symbols-outlined">delete</span>
            }
            handleSort={handleSort}
            getRow={getRow}
            handleDelete={handleDeleteModal}
            handleEdit={handleEditAction}
            loading={isFetching}
            clear={contactState?.clearSelection}
            perpage={contactState?.currentPageSize}
            assignable={false}
            deletable={contactList?.data?.delete_permission}
            editable={contactList?.data?.edit_permission}
            showCheckBox={true}
          />
        )}

        {contactList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={contactState?.currentPage}
            totalPageCount={Math.ceil(
              contactList.data.total_count / contactState.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === contactState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={contactList?.data?.fields || []}
              moduleId={contactList?.data?.module_id}
              updateData={updateContactFields}
            />
          </div>
        </ModalLayout>
        <ModalLayout
          show={contactState?.showDeleteModal}
          handleClose={handleDeleteModal}
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={"Are you sure delete the selected Contact Information ?"}
              subTitle={"This action can't be undo "}
              cancelText={"No"}
              cancelAction={handleDeleteModal}
              submitText={"Yes"}
              submitAction={handleDelete}
              isRight={true}
            />
          </div>
        </ModalLayout>
        <ModalLayout
          show={contactState?.showEditModal}
          handleClose={handleEditAction}
          title={`Update contact information`}
        >
          <div className="pro-m-5">
            <AddNote
              isStickyFooter
              handleClose={handleCloseModal}
              refetch={refetch}
            />
          </div>
        </ModalLayout>
      </div>
    </>
  );
};

export default ContactUs;
